import gql from 'graphql-tag';

export default gql`
mutation($prevLink: String, $nextLink: String) {
  setPageNavigationLinks(prevLink: $prevLink, nextLink: $nextLink) @client
}
`;
